module.exports = __webpack_public_path__ + "static/media/bublina.470fe67d.webp";